<template>
  <div class="row justify-content-between mb_20 updateclient">
    <!-- Heading Section -->
    <div class="col-xl-12 col-xxl-5">
      <div class="heading mb_20">
        <h2>{{ heading }}</h2>
        <h3>{{ subheading }}</h3>
      </div>
    </div>

    <!-- Tabs Section -->
    <div class="col-xl-12 col-xxl-7">
      <div
        class="alche_btn tab_report toggle_switch list_card_switch mb_20 d-flex justify-content-sm-start justify-content-md-end"
      >
        <ul
          id="myTab"
          role="tablist"
          class="nav nav-tabs list_tabs btn-reports"
        >
          <li
            v-for="(tab, index) in tabs"
            :key="index"
            role="presentation"
            class="nav-item list-item"
          >
            <button
              :id="`${tab.id}-tab`"
              :disabled="activeTab === tab.id"
              @click="onTabClick(tab)"
              :data-bs-toggle="'tab'"
              :data-bs-target="`#${tab.id}`"
              type="button"
              role="tab"
              :aria-controls="tab.id"
              :aria-selected="activeTab === tab.id"
              :class="['nav-link list-link', { active: activeTab === tab.id }]"
            >
              {{ tab.label }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientHeaderTabs",
  props: {
    heading: {
      type: String,
      required: true,
    },
    subheading: {
      type: String,
      required: true,
    },
    tabs: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
    handleTabClick: {
      type: Function,
      required: true,
    },
  },
  methods: {
    onTabClick(tab) {
      this.handleTabClick(tab);
    },
  },
};
</script>
